var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-btn',{staticStyle:{"margin":"0"},attrs:{"text":"","href":_vm.url,"target":"_blank","color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("cloud_download")]),_vm._v(" Documento ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }